import Product from './Product';
import {get, writable} from 'svelte/store';

const data = {index: undefined, restored: false};
const basket = writable(data);

async function clearE2() {
	try {
		const product = get(Product);
		let url = Product.getURL();
		url += `?basket_${product.id}=&basket=`;
		const response = await fetch(url);
	}
	catch (error) {
		console.error(error);
	}
}

basket.getIndex = () => {
	const index = data.index;
	return /^\d+$/.test(index) ? index : '';
};

basket.setIndex = index => {
	if (/^\d+$/.test(index)) {
		data.index = index;
		data.restored = basket.isIndex();
		basket.set(data);
	}
};

basket.isIndex = () => {
	const index = data.index;
	return /^\d+$/.test(index);
};

basket.setClear = async () => {
	data.index = '';
	data.restored = false;
	basket.set(data);
	await clearE2();
};

export default basket;